// Feature flag для движка FAB Музы (Шаг 7 миграции на XState).
//
// Источник правды — localStorage["MUSA_FAB_ENGINE"]. URL-параметр ?fab=
// перезаписывает LS значение (удобно для тестирования на проде Боссом
// без DevTools — открыл https://muzaai.ru/?fab=xstate и сохранилось).
//
// Default — 'legacy' (Босс 2026-06-04): старый FloatingConsultant у всех —
// графическая Муза + облачко настроек. XState-движок — по opt-in ?fab=xstate
// (сохраняется в LS). Reuse-working-solutions rule — рабочая legacy не трогается.
//
// Связано с правилами CLAUDE.md:
//  - Reuse-working-solutions rule — старый компонент остаётся как fallback
//  - Frontend-incident-deep-debug rule — если новый FAB упадёт, Босс быстро
//    откатит через ?fab=legacy без деплоя
//  - Pre-push critical review rule — default 'legacy', никаких регрессий
//    у юзеров без явного opt-in

const STORAGE_KEY = "MUSA_FAB_ENGINE";
const URL_PARAM = "fab";

export type FabEngine = "legacy" | "xstate";

function isFabEngine(value: unknown): value is FabEngine {
  return value === "legacy" || value === "xstate";
}

export function getFabEngine(): FabEngine {
  if (typeof window === "undefined") return "xstate";

  // 1. URL override (?fab=xstate / ?fab=legacy) — сохраняется в LS,
  //    чтобы не таскать query-string по всем последующим переходам.
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get(URL_PARAM);
    if (isFabEngine(fromUrl)) {
      try {
        window.localStorage.setItem(STORAGE_KEY, fromUrl);
      } catch {
        // SecurityError / quota — ignored, движок всё равно вернём ниже.
      }
      return fromUrl;
    }
  } catch {
    // URLSearchParams ошибка — переходим к LS.
  }

  // 2. LS-значение, если установлено ранее.
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (isFabEngine(stored)) return stored;
  } catch {
    // SecurityError — fallback на default.
  }

  // 3. Default — legacy (Босс 2026-06-04: вернуть старый FAB — графическая
  //    Муза + облачко настроек). XState-движок доступен по opt-in ?fab=xstate.
  return "xstate";
}

export function setFabEngine(engine: FabEngine): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, engine);
  } catch {
    // Ignore quota/security errors — UI должен пережить отсутствие LS.
  }
}
